import { ButtonFlavor, ButtonSize, ButtonType, ExButton, ExIcon, IconSize } from '@boomi/exosphere';
import { useRef, useState } from 'react';
import './account-menu.css';
import { useClickOutside } from '../utils/useClickOutside';
import type { JwtToken } from '../../types/global';

const AccountMenu = ({ jwt }: { jwt: JwtToken }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const popupRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useClickOutside([popupRef, buttonRef], () => setIsMenuOpen(false), isMenuOpen);

    const { accountId, username } = jwt;

    return (
        <div className="account-menu">
            <button
                ref={buttonRef}
                className="account-menu-button"
                title={username}
                type="button"
                onClick={toggleMenu}
            >
                {username}
            </button>
            {isMenuOpen && (
                <div className="account-menu-content" ref={popupRef}>
                    <span className="account-menu-header">Currently signed in</span>
                    <div className="account-info-section">
                        <ExIcon icon="User" size={IconSize.S} />
                        <span className="account-id-text">
                            {username}
                            <br />
                            ID: {accountId}
                        </span>
                        <ExIcon icon="Check" size={IconSize.XS} />
                    </div>
                    <div className="account-divider" />
                    <a
                        className="account-settings-button"
                        href={`https://platform.boomi.com/AtomSphere.html#settings;accountId=${accountId};type=account`}
                        target="_blank"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <ExIcon icon="Settings" size={IconSize.S} />
                        Settings
                    </a>
                    <div className="account-divider" />
                    <ExButton
                        className="sign-out-button"
                        flavor={ButtonFlavor.BRANDED}
                        type={ButtonType.SECONDARY}
                        onClick={() => {
                            window.location.href = `https://platform.boomi.com/Home.html#home;accountId=${accountId}`;
                            setIsMenuOpen(false);
                        }}
                        size={ButtonSize.DEFAULT}
                    >
                        <ExIcon icon="Sign out" slot="prefix" />
                        Sign Out
                    </ExButton>
                </div>
            )}
        </div>
    );
};

export default AccountMenu;
